import { useRef } from 'react'
import { useChatStore } from '@/stores/useChatStore'
import NotificationManager from '@/utils/notification-manager'

/**
 * 通知系统管理 Hook
 * 封装通知系统的初始化、权限管理和状态监听
 */
export function useNotificationSystem() {
  const notificationManager = useRef<NotificationManager>(NotificationManager.getInstance())

  /**
   * 初始化通知系统
   */
  const initializeNotification = async () => {
    try {
      // 请求通知权限
      const permission = await notificationManager.current.requestPermission()
      if (permission === 'granted') {
        console.log('通知权限已获取')
      } else {
        console.warn('通知权限被拒绝')
      }

      // 监听聊天状态变化来更新未读计数
      const unsubscribe = useChatStore.subscribe(
        (state: any) => state.conversations,
        (conversations: any[]) => {
          const totalUnread = conversations.reduce((total: number, conv: any) => total + (conv.unreadCount || 0), 0)
          notificationManager.current.setUnreadCount(totalUnread)
        }
      )

      return unsubscribe
    } catch (error) {
      console.error('初始化通知系统失败:', error)
    }
  }

  /**
   * 清理通知系统资源
   */
  const cleanupNotification = () => {
    notificationManager.current.destroy()
  }

  /**
   * 获取通知管理器实例
   */
  const getNotificationManager = () => {
    return notificationManager.current
  }

  return {
    initializeNotification,
    cleanupNotification,
    getNotificationManager
  }
}
